import { TableHead } from "@/components/common/table/table";
import { SortableTableHead } from "@/components/dataPages/loadboard";

// Column headers for the truck list table. Sortable columns render the shared
// sort arrows; the rest are plain headers. The Location column sorts by
// `locationSortKey`, which is distance while a location is searched.
export const TruckListTableHeader = ({ sort, onSort, locationSortKey = "location" }) => (
    <thead className="bg-cm-p-surface-container">
        <tr className="[&_th]:text-xs [&_th]:font-medium [&_th]:uppercase [&_th]:tracking-normal [&_th]:text-cm-p-text-primary">
            <SortableTableHead sortKey="age" currentSort={sort} onSort={onSort}>
                Age
            </SortableTableHead>
            <TableHead>Truck number</TableHead>
            <SortableTableHead sortKey="equipment" currentSort={sort} onSort={onSort}>
                Equipment
            </SortableTableHead>
            <SortableTableHead sortKey={locationSortKey} currentSort={sort} onSort={onSort}>
                Location
            </SortableTableHead>
            <SortableTableHead sortKey="readyDate" currentSort={sort} onSort={onSort}>
                Ready date
            </SortableTableHead>
            <SortableTableHead sortKey="dispatcher" currentSort={sort} onSort={onSort}>
                Dispatcher
            </SortableTableHead>
            <TableHead>Contact</TableHead>
            <TableHead>Note</TableHead>
        </tr>
    </thead>
);
